var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { useRef } from 'react';
import Schema from 'async-validator';
/**
 * 用于存储表单的数据
 */
var FormStore = /** @class */ (function () {
    function FormStore() {
        var _this = this;
        this.store = {}; // 存放表单中所有的数据 eg. {password: "ddd",username: "123"}
        this.fieldEntities = []; // 所有的组件实例
        this.callbacks = {}; // 成功和失败的回调
        this.errList = [];
        /**
         * 注册组件实例
         * @param field
         */
        this.registerField = function (field) {
            _this.fieldEntities.push(field);
            return function () {
                _this.fieldEntities = _this.fieldEntities.filter(function (item) { return item != field; });
                delete _this.store[field.props.name];
            };
        };
        this.getFieldValue = function (name) {
            return _this.store[name];
        };
        /**
         * 存储组件数据
         * @param newStore { [name]: newValue }
         */
        this.setFieldsValue = function (newStore) {
            _this.store = __assign(__assign({}, _this.store), newStore);
            _this.fieldEntities.forEach(function (enetity) {
                var name = enetity.props.name;
                Object.keys(newStore).forEach(function (key) {
                    if (key === name) {
                        enetity.onStoreChange();
                    }
                });
            });
        };
        /**
         * 表单校验
         * rules: { required: true, message: '' }
         * descriptor: {
         *    username: {
         *      type: 'string',
         *      required: true,
         *      validator: (rule, value) => {
         *        return /^[a-zA-Z0-9]+$/.test(value)
         *      },
         *    },
         *  }
         */
        this.validate = function () {
            var err = [];
            _this.errList.length = 0;
            _this.fieldEntities.forEach(function (entity) {
                var _a;
                var _b = entity.props, name = _b.name, _c = _b.rules, rules = _c === void 0 ? [] : _c;
                var descriptor = {};
                if (rules.length) {
                    // 多条校验规则
                    if (rules.length > 1) {
                        descriptor[name] = [];
                        rules.map(function (v) {
                            descriptor[name].push(v);
                        });
                    }
                    else {
                        descriptor[name] = rules[0];
                    }
                }
                var validator = new Schema(descriptor);
                //@ts-ignore
                validator.validate((_a = {}, _a[name] = _this.store[name], _a), function (errors) {
                    var _a;
                    if (errors) {
                        err.push.apply(err, __spread(errors));
                        (_a = _this.errList).push.apply(_a, __spread(errors));
                        // 表单项更新
                    }
                    entity.onStoreChange();
                });
            });
            return err;
        };
        this.submit = function () {
            var err = _this.validate();
            if (err.length === 0) {
                _this.callbacks.onFinish(_this.store);
            }
            else if (err.length > 0) {
                _this.callbacks.onFinishFailed(err);
            }
        };
        this.setCallback = function (callback) {
            _this.callbacks = __assign(__assign({}, _this.callbacks), callback);
        };
        this.getForm = function () {
            return {
                setCallback: _this.setCallback,
                registerField: _this.registerField,
                getFieldValue: _this.getFieldValue,
                setFieldsValue: _this.setFieldsValue,
                submit: _this.submit,
                store: _this.store,
                errList: _this.errList,
                fieldEntities: _this.fieldEntities,
            };
        };
    }
    return FormStore;
}());
export default function useForm(form) {
    var formRef = useRef();
    if (!formRef.current) {
        if (form) {
            formRef.current = form;
        }
        else {
            var formStore = new FormStore();
            formRef.current = formStore.getForm();
        }
    }
    return [formRef.current];
}
